import { useState } from 'react';

// Лёгкая (i)-подсказка для ЛК клиники, светлая тема. items: [[label, desc], ...]
const TIP_WIDTH = 300;

export default function StatusInfo({ title, items }) {
  const [pos, setPos] = useState(null);

  const open = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    let left = r.left + r.width / 2 - TIP_WIDTH / 2;
    left = Math.max(8, Math.min(left, window.innerWidth - TIP_WIDTH - 8));
    setPos({ left, top: r.bottom + 8 });
  };

  return (
    <span style={s.wrap} onMouseEnter={open} onMouseLeave={() => setPos(null)}>
      <span style={s.icon}>i</span>
      {pos && (
        <span style={{ ...s.tip, left: pos.left, top: pos.top }}>
          {title && <span style={s.tipTitle}>{title}</span>}
          {items.map(([label, desc]) => (
            <span key={label} style={s.tipRow}>
              <b style={s.tipLabel}>{label}</b>
              <span style={s.tipDesc}>{desc}</span>
            </span>
          ))}
        </span>
      )}
    </span>
  );
}

const s = {
  wrap: { position: 'relative', display: 'inline-flex', verticalAlign: 'middle', marginLeft: 6 },
  icon: {
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    width: 13, height: 13, borderRadius: '50%', border: '1.2px solid #94a3b8',
    color: '#94a3b8', fontSize: 9, fontFamily: 'Georgia, serif', fontStyle: 'italic', fontWeight: 700,
    textTransform: 'none', cursor: 'help', userSelect: 'none', lineHeight: 1, flexShrink: 0,
  },
  tip: {
    position: 'fixed', zIndex: 1000, width: TIP_WIDTH,
    background: '#fff', border: '1px solid #e2e8f0', borderRadius: 10, padding: '12px 14px',
    boxShadow: '0 10px 30px rgba(27,43,75,0.15)', textAlign: 'left', textTransform: 'none',
    display: 'flex', flexDirection: 'column', gap: 8, whiteSpace: 'normal', cursor: 'default',
  },
  tipTitle: { color: '#1B2B4B', fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.4 },
  tipRow: { display: 'flex', flexDirection: 'column', gap: 2 },
  tipLabel: { color: '#149e90', fontSize: 13, fontWeight: 600 },
  tipDesc: { color: '#64748b', fontSize: 12, lineHeight: 1.4, fontWeight: 400 },
};
